import {ReactNode} from 'react';
import NOFilter from '../no-filter';
import {FilterProps} from '../filter-types';
import {Data_1} from '@carbon/icons-react';

type FilterContainerProps = {
    filterConfiguration: Array<FilterProps>;
    children?: ReactNode;
    horizontal?: boolean;
    rosterSelectionComponent?: ReactNode;
    // Pages that already have an h1 pass 'h2' to keep the heading outline in order
    headingTag?: 'h1' | 'h2';
};

// Multi-select filters don't support `searchable`, so only default it on for single-select filters
const withSearchable = (filter: FilterProps): FilterProps =>
    filter.enableMultiSelect ? filter : {searchable: true, ...filter};

const FilterContainer = ({
    filterConfiguration,
    children,
    horizontal = false,
    rosterSelectionComponent,
    headingTag: Heading = 'h1',
}: FilterContainerProps) => {
    if (horizontal) {
        return (
            <div className='flex flex-row items-center justify-between gap-8 w-full'>
                {filterConfiguration.map((filter, index) => (
                    <div key={`filter-${index}`} className='flex-1'>
                        <NOFilter {...withSearchable(filter)} />
                    </div>
                ))}
                {children}
            </div>
        );
    }

    return (
        <div className='geography-filters bg-white py-4 px-6 w-64 min-h-[calc(100%)] flex flex-col'>
            <div className='flex flex-row items-center justify-between'>
                <Heading className='text-lg font-semibold'>Filters</Heading>
                <Data_1 aria-hidden='true' />
            </div>

            {/* Roster selection component (for roster comparison) */}
            {rosterSelectionComponent}

            {filterConfiguration.map((f, i) => (
                <NOFilter key={i} {...withSearchable(f)} />
            ))}

            {children}
        </div>
    );
};

export default FilterContainer;
